import { useEffect, useRef, useState } from "react";
import styles from "./EditContact.module.css";
import TextInput from "../../Components/TextInput/InputText";
import { connect, useDispatch } from "react-redux";
import { contactResources, editContact, fetchConstants, fetchNewPropertySubType, fetchpropertySubType, fetchpropertyType } from "../../Services/contacts";
import Loading from "../../Components/Loading/Loading";
import { AiOutlineClose } from "react-icons/ai";
import { useLocation } from "react-router";
import { showSnackbarAction } from "../../Redux/actions";
import { country_code, url } from "../../Values/constants";
import { themeColors } from "../../Components/theme";
import axios from "axios";
import "../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import DropDownText from "../../Components/DropDownText/DropDownText";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import PhoneNumberWrapper from "../../Components/TextInput/PhoneNumberWrapper";
import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

export interface CountryData {
  name: string;
  dialCode: string;
  countryCode: string;
  format: string;
}

const EditContact = ({
  history,
  userRole,
  theme,
  user,
  conatctHeader,
  authToken
}: {
  history: any;
  userRole: any;
  theme: any;
  user: any;
  conatctHeader: any;
  authToken: any;
}) => {
  console.log("users", user);
  const location: any = useLocation();
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  // console.log("Contact headers details :", location.state.detail);
  const dispatcher = useDispatch();
  const firstNameRef: any = useRef();
  const lastNameRef: any = useRef();
  const emailRef: any = useRef();
  const numberRef: any = useRef();
  const alternateNumberRef: any = useRef();
  const otherNotIntRef: any = useRef();
  const otherLostRef: any = useRef();
  const leadSourceRef: any = useRef();
  const oneFieldRef: any = useRef();
  const twoFieldRef: any = useRef();
  const threeFieldRef: any = useRef();
  const fourFieldRef: any = useRef();
  const fiveFieldRef: any = useRef();
  const sixFieldRef: any = useRef();
  const [load, setLoad] = useState(false);
  const [locationsList, setLocationsList] = useState<any[]>([]);
  const [budgetsList, setBudgetsList] = useState<any[]>([]);
  const [projectsList, setProjectsList] = useState<any[]>([]);
  const [notIntReasonList, setNotIntReasonList] = useState<any[]>([]);
  const [lostReasonList, setLostReasonList] = useState<any[]>([]);
  const [propertyTypeList, setPropertyTypeList] = useState<any[]>([]);
  const [oldPropertyTypeList, setOldPropertyTypeList] = useState<any[]>([]);
  const [allPropertySubTypeList, setAllPropertySubTypeList] = useState<any[]>([]);
  const [propertyStageList, setPropertyStageList] = useState<any[]>([]);
  const [addSet, setAddSet] = useState<any[]>([]);
  const [addSetSelected, setAddSetSelected] = useState<any>({ label: "Select", value: "Select" });
  const [stageSelected, setStageSelected] = useState<any>({ label: "Select", value: "Select" });
  const [campaignSetSelected, setCampaignSelected] = useState<any>({ label: "Select", value: "Select" });
  const [propertyTypeSelected, setPropertyTypeSelected] = useState<any>({ label: "Select", value: "Select" });
  const [propertyStageSelected, setPropertyStageSelected] = useState<any>({ label: "Select", value: "Select" });
  const [locationSelected, setlocationSelected] = useState<any>({ label: "Select", value: "Select" });
  const [budgetSelected, setBudgetSelected] = useState<any>({ label: "Select", value: "Select" });
  const [projectSelected, setProjectSelected] = useState<any>({ label: "Select", value: "Select" });
  const [leadTypeList, setleadTypeList] = useState<any[]>([]);
  const [leadSourceSelected, setLeadSourceSelected] = useState<any>({ label: location.state.detail.lead_source ? location.state.detail.lead_source : "Select", value: location.state.detail.lead_source ? location.state.detail.lead_source : "Select" });
  const [propertySubTypeSelected, setPropertySubTypeSelected] = useState<any>({ label: location.state.detail.property_sub_type ? location.state.detail.property_sub_type : "Select", value: location.state.detail.property_sub_type ? location.state.detail.property_sub_type : "Select" });
  const [leadTypeSelected, setLeadTypeSelected] = useState<any>({ label: "Select", value: "Select" });
  const [leadSourceList, setLeadSourceList] = useState<any[]>([]);
  const [comTypes, setComTypes] = useState<any[]>([]);
  const [resTypes, setResTypes] = useState<any[]>([]);
  const [propertySubType, setPropertySubType] = useState<any[]>([]);
  const [countryCode, setCountryCode] = useState<string>("");
  const [countryCodeList, setCountryCodeList] = useState<string[]>([]);
  const [campaign, setCampaign] = useState<any[]>([]);
  const stage = [
    { label: "FRESH", value: "FRESH" },
    { label: "WON", value: "WON" },
    { label: "CALL BACK", value: "CALL BACK" },
    { label: "INTERESTED", value: "INTERESTED" },
    { label: "LOST", value: "LOST" },
    { label: "NOT-INTERESTED", value: "NOT-INTERESTED" }
  ];
  const [maxHeight, setMaxHeight] = useState(window.innerHeight * 0.8); // Set an initial value, adjust as needed

  const handleResize = () => {
    // Update maxHeight when the window is resized
    setMaxHeight(window.innerHeight * 0.8); // Adjust the multiplier as needed
  };

  useEffect(() => {
    // Add event listener for window resize
    window.addEventListener('resize', handleResize);
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (authToken) {
      getLeadsFilterValues();
    }
  }, [user.uid, authToken]);

  const getLeadsFilterValues = async () => {
    axios.defaults.headers.common['x-access-token'] =
      authToken
    const res = await axios.post(url + '/leads/filterValues', {
      uid: user.uid,
    });
    setAddSet(res.data[0]?.addset);
    setCampaign(res.data[0]?.campaign);
  }

  useEffect(() => {
    let data: any[] = [];
    country_code.forEach((item) => {
      data.push(item.dial_code + " " + item.name);
    });
    setCountryCodeList(data);
    if (location.state.detail.country_code) {
      setCountryCode(location.state.detail.country_code);
    }
  }, []);

  const choice = () => {
    let data = countryCodeList.map((item: any) => ({
      value: item,
      label: item,
    }));
    return data;
  };

  useEffect(() => {
    const unsub = contactResources(
      location.state.detail.organization_id,
      (data) => setLocationsList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
      (data) => setBudgetsList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
      (data) => setProjectsList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
      (data) => setLeadSourceList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ));
    const unsubConst = fetchConstants(
      (data) => setNotIntReasonList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
      (data) => setLostReasonList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
      (data) => setPropertyStageList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
      (data) => setOldPropertyTypeList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      )
    );
    const unNewPropertyType = fetchpropertyType(
      user.organization_id,
      (data) => setPropertyTypeList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      )
    );
    const unNewPropertySubType = fetchNewPropertySubType(
      user.organization_id,
      (data) => setAllPropertySubTypeList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      )
    );
    let data = [
      { label: "Data", value: "Data" },
      { label: "Leads", value: "Leads" }
    ];
    setleadTypeList(data);
    const unsubProperty = fetchpropertySubType(
      location.state.detail.organization_id,
      (data) => setComTypes(data),
      (data) => setResTypes(data),
      (data) => setLeadSourceList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      )
    );
    return () => {
      unsub();
      unsubConst();
      unsubProperty();
      unNewPropertyType();
      unNewPropertySubType();
    };
  }, []);

  useEffect(() => {
    const filteredArray = allPropertySubTypeList.filter(item => item.property_type === propertyTypeSelected.value);
    const propertySubTypes = filteredArray.map(item => item.property_sub_type);
    if (propertySubTypes.length !== 0) {
      setPropertySubType(propertySubTypes);
    } else {
      setPropertySubType([]);
    }
  }, [propertyTypeSelected]);

  useEffect(() => {
    setlocationSelected({
      label: location.state.detail.location,
      value: location.state.detail.location,
    });
    setBudgetSelected({
      label: location.state.detail.budget,
      value: location.state.detail.budget,
    });
    setProjectSelected({
      label: location.state.detail.project,
      value: location.state.detail.project,
    });
    setLeadTypeSelected({
      label: location.state.detail.lead_type,
      value: location.state.detail.lead_type,
    });
    setPropertyStageSelected({
      label: location.state.detail.property_stage,
      value: location.state.detail.property_stage,
    });
    setPropertyTypeSelected({
      label: location.state.detail.property_type,
      value: location.state.detail.property_type,
    });
    setCampaignSelected({
      label: location.state.detail.campaign,
      value: location.state.detail.campaign,
    });
    setAddSetSelected({
      label: location.state.detail.addset,
      value: location.state.detail.addset,
    });
  }, [locationsList, budgetsList, notIntReasonList, projectsList, lostReasonList, propertyTypeList, propertyStageList, leadTypeList, addSet, campaign]);

  const handlePhoneChange = (value: string, country: CountryData) => {
    setCountryCode(`+${country?.dialCode}`);
  };

  const handleCheck = () => {
    const numberExp = /^[0-9]+$/;

    if (firstNameRef.current.value === "") {
      firstNameRef.current.value =
        location.state.detail.customer_name.split(" ")[0];
    }
    if (lastNameRef.current.value === "") {
      lastNameRef.current.value =
        location.state.detail.customer_name.split(" ")[1] || "";
    }
    if (emailRef.current.value === "") {
      emailRef.current.value = location.state.detail.email;
    }
    if (numberRef.current.value === "") {
      numberRef.current.value = location.state.detail.contact_no;
    }
    if (alternateNumberRef.current.value === "") {
      alternateNumberRef.current.value = location.state.detail.alternate_no;
    }
    if (stageSelected.label === "Select") {
      stageSelected.label = location.state.detail.stage;
    }
    if (propertyTypeSelected.label === "Select") {
      propertyTypeSelected.label = location.state.detail.property_type;
    }
    if (propertyStageSelected.label === "Select") {
      propertyStageSelected.label = location.state.detail.property_stage;
    }
    if (locationSelected.label === "Select") {
      locationSelected.label = location.state.detail.location;
    }
    if (budgetSelected.label === "Select") {
      budgetSelected.label = location.state.detail.budget;
    }
    if (projectSelected.label === "Select") {
      projectSelected.label = location.state.detail.project;
    }
    if (campaignSetSelected.label === "Select") {
      campaignSetSelected.label = location.state.detail.campaign;
    }
    if (addSetSelected.label === "Select") {
      addSetSelected.label = location.state.detail.addset;
    }
    if (oneFieldRef.current.value !== "") {
      if (!numberExp.test(oneFieldRef.current.value)) {
        dispatcher(
          showSnackbarAction(
            `${conatctHeader.find((obj: any) => obj.label === "field_one").value} contain only number!!`,
            "error"
          )
        );
        return;
      }
    }
    if (twoFieldRef.current.value !== "") {
      if (!numberExp.test(twoFieldRef.current.value)) {
        dispatcher(
          showSnackbarAction(
            `${conatctHeader.find((obj: any) => obj.label === "field_two").value} contain only number!!`,
            "error"
          )
        );
        return;
      }
    }
    if (oneFieldRef.current.value === "") {
      oneFieldRef.current.value =
        location.state.detail.field_one;
    }
    if (twoFieldRef.current.value === "") {
      twoFieldRef.current.value =
        location.state.detail.field_two;
    }
    if (threeFieldRef.current.value === "") {
      threeFieldRef.current.value =
        location.state.detail.field_three;
    }
    if (fourFieldRef.current.value === "") {
      fourFieldRef.current.value =
        location.state.detail.field_four;
    }
    if (fiveFieldRef.current.value === "") {
      fiveFieldRef.current.value =
        location.state.detail.field_five;
    }
    if (sixFieldRef.current.value === "") {
      sixFieldRef.current.value =
        location.state.detail.field_six;
    }
    if (!(leadTypeSelected.value === "Leads" || leadTypeSelected.value === "Data")) {
      dispatcher(
        showSnackbarAction(
          "Lead Type Required!!",
          "error"
        )
      );
      return;
    }
    return true;
  };

  const edit = async (e: any) => {
    e.preventDefault();
    const val = handleCheck();
    if (val) {
      setLoad(true);
      editContact(
        location.state.detail.contactId,
        firstNameRef.current.value,
        lastNameRef.current.value || "",
        numberRef.current.value,
        alternateNumberRef.current.value,
        stageSelected.label,
        projectSelected.label,
        budgetSelected.label,
        locationSelected.label,
        propertyTypeSelected.label,
        propertyStageSelected.label,
        leadTypeSelected.value === "Select" ? "Data" : leadTypeSelected.value,
        leadSourceSelected.value,
        addSetSelected.label,
        campaignSetSelected.label,
        oneFieldRef.current.value,
        twoFieldRef.current.value,
        threeFieldRef.current.value,
        fourFieldRef.current.value,
        fiveFieldRef.current.value,
        sixFieldRef.current.value,
        dispatcher,
        history,
        (data) => setLoad(data),
        numberRef.current.value === location.state.detail.contact_no && alternateNumberRef.current.value === location.state.detail.alternate_no ? false : true,
        location.state.detail.organization_id,
        propertySubTypeSelected.value === "Select" ? "" : propertySubTypeSelected.value,
        countryCode.split(" ")[0],
        numberRef.current.value === location.state.detail.contact_no ? false : true,
        alternateNumberRef.current.value === location.state.detail.alternate_no ? false : true,
        emailRef.current.value
      );
    }
  };
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  return (
    <Box className={styles.parent} sx={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
      {load && <Loading />}
      {isMobile && (
        <Box
          className="d-flex flex-row w-100 px-4 pt-4"
        >
          <h5
            style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}
          >
            Edit Contact Details
          </h5>
          <AiOutlineClose
            className={styles.closeIcon}
            size={25}
            onClick={() => history.replace("/")}
          />
        </Box>
      )}
      <Box
        className={`w-100 d-flex flex-column gap-2 ${isMobile ? "px-1" : "px-4"}`}
        style={{
          padding: isMobile ? '0' : '',
          maxWidth: isMobile ? '100vw' : undefined,
          margin: isMobile ? '0' : '0 auto',
          overflowY: 'auto',
          maxHeight: isMobile ? 'calc(100vh - 120px)' : "calc(100vh - 50px)",
        }}
      >
        <form
          className={`card shadow rounded mt-2${!isMobile ? ` ${styles.forcePadding}` : ""}`}
          style={{
            ...cardContainerStyles,
            padding: isMobile ? '16px' : '32px 8px 8px 32px',
            boxSizing: 'border-box',
            minHeight: isMobile ? 'auto' : undefined,
            marginBottom: isMobile ? '50px' : 0,
          }}
        >
          <Grid container spacing={isMobile ? 2 : 3}>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="First Name"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={firstNameRef}
                value={location.state.detail.customer_name.split(" ")[0]}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="Last Name"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={lastNameRef}
                value={location.state.detail.customer_name.slice(
                  location.state.detail.customer_name.split(" ")[0].length
                )}
                // required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "contact_no").value}
                style={
                  userRole !== "Lead Manager"
                    ? { backgroundColor: "#f5f5f5", width: "100%" }
                    : { backgroundColor: "#fff", width: '100%' }
                }
                ref={numberRef}
                disabled={userRole !== "Lead Manager" ? true : false}
                value={location.state.detail.contact_no}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "alternate_no").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={alternateNumberRef}
                value={location.state.detail.alternate_no}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "stage").value}
                options={stage}
                value={stageSelected.value === "Select" ? "" : stageSelected.value}
                onChange={(e: any) => setStageSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "project").value}
                options={projectsList}
                value={projectSelected.value === "Select" ? "" : projectSelected.value}
                onChange={(e: any) => setProjectSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "location").value}
                options={locationsList}
                value={locationSelected.value === "Select" ? "" : locationSelected.value}
                onChange={(e: any) => setlocationSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "budget").value}
                options={budgetsList}
                value={budgetSelected.value === "Select" ? "" : budgetSelected.value}
                onChange={(e: any) => setBudgetSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "property_type").value}
                options={propertyTypeList}
                value={propertyTypeSelected.value === "Select" ? "" : propertyTypeSelected.value}
                onChange={(e: any) => setPropertyTypeSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "property_stage").value}
                options={propertyStageList}
                value={propertyStageSelected.value === "Select" ? "" : propertyStageSelected.value}
                onChange={(e: any) => setPropertyStageSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "property_sub_type").value}
                options={propertySubType}
                value={propertySubTypeSelected.value === "Select" ? "" : propertySubTypeSelected.value}
                onChange={(e: any) => setPropertySubTypeSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <PhoneNumberWrapper
                title="Country Code"
                value={countryCode || ''}
                handlePhoneChange={handlePhoneChange}
                disabled={true}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "lead_type").value}
                options={leadTypeList}
                value={leadTypeSelected.value === "Select" ? "" : leadTypeSelected.value}
                onChange={(e: any) => setLeadTypeSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
                required={true}
              />
            </Grid>
            {user.profile === "Lead Manager" && (
              <>
                <Grid item xs={12} sm={4}>
                  <DropDownText
                    title={conatctHeader.find((obj: any) => obj.label === "lead_source").value}
                    options={leadSourceList}
                    value={leadSourceSelected.value === "Select" ? "" : leadSourceSelected.value}
                    onChange={(e: any) => setLeadSourceSelected({ value: e.target.value, label: e.target.value })}
                    labelKey="label"
                    valueKey="value"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DropDownText
                    title={conatctHeader.find((obj: any) => obj.label === "addset").value}
                    options={addSet}
                    value={addSetSelected.value === "Select" ? "" : addSetSelected.value}
                    onChange={(e: any) => setAddSetSelected({ value: e.target.value, label: e.target.value })}
                    labelKey="label"
                    valueKey="value"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DropDownText
                    title={conatctHeader.find((obj: any) => obj.label === "campaign").value}
                    options={campaign}
                    value={campaignSetSelected.value === "Select" ? "" : campaignSetSelected.value}
                    onChange={(e: any) => setCampaignSelected({ value: e.target.value, label: e.target.value })}
                    labelKey="label"
                    valueKey="value"
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={4}>
              <TextInput
                title="Email"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={emailRef}
                value={location.state.detail.email}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "field_one").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={oneFieldRef}
                value={location.state.detail.field_one}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "field_two").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={twoFieldRef}
                value={location.state.detail.field_two}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "field_three").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={threeFieldRef}
                value={location.state.detail.field_three}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "field_four").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={fourFieldRef}
                value={location.state.detail.field_four}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "field_five").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={fiveFieldRef}
                value={location.state.detail.field_five}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "field_six").value}
                ref={sixFieldRef}
                value={location.state.detail.field_six}
              />
            </Grid>
            {/* Remove submit button from inside form for mobile */}
            {!isMobile && (
              <Grid item xs={12} style={{ marginTop: 12 }}>
                <StyledSubmitButton
                  onClick={(e: any) => edit(e)}
                  themeMode={themeMUI.palette.mode}
                >
                  {load ? (
                    <span style={{ display: "flex", justifyContent: "center" }}>
                      <Circles color="#fff" height={20} width={20} />
                    </span>
                  ) : (
                    <>Submit</>
                  )}
                </StyledSubmitButton>
              </Grid>
            )}
          </Grid>
        </form>
      </Box>
      {isMobile && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            bgcolor: "white",
            p: 2,
            borderTop: "1px solid #ddd",
            boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
            zIndex: 100,
          }}
        >
          <StyledSubmitButton
            onClick={(e: any) => edit(e)}
            themeMode={themeMUI.palette.mode}
            isMobile={isMobile}
          >
            {load ? (
              <span style={{ display: "flex", justifyContent: "center" }}>
                <Circles color="#fff" height={20} width={20} />
              </span>
            ) : (
              <>Submit</>
            )}
          </StyledSubmitButton>
        </Box>
      )}
    </Box>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userRole: state.user.role,
    theme: state.theme.isLightMode,
    user: state.user.data,
    conatctHeader: state.contactHeaderList.data,
    authToken: state.user.authToken
  };
};

export default connect(mapStateToProps)(EditContact);
